module.exports = __webpack_public_path__ + "img/compass.cf7114ef.svg";